
'use strict';

export default function routes($stateProvider) 
{
	'ngInject';

	//console.log("Importing champs_admin:routes");
	$stateProvider
		.state('mychamps', {
			url: '/mychamps',
			params: null,
			template: require('./mychamps.html'),
			controller: 'MyChampsController',
			controllerAs: 'vm',
			authenticate: true
		})
		.state("champcategoryedit", {
			url: "/cce/{id:int}",
			params: {id: null},
			template: require("./champ_categoryedit.html"),
			controller: "ChampCategoryEditController",
			controllerAs: 'vm',
			authenticate: true
		})
		.state("champedit", { 
			url: "/ce", 
			params: {id: null}, 
			template: require("./champ_edit.html"), 
			controller: "ChampEditController",
			controllerAs: 'vm',
			authenticate: true
		})
		.state("champadd", { 
			url: "/ca", 
			template: require("./champ_add.html"),
			controller: "ChampAddController",
			controllerAs: 'vm',
			authenticate: true 
		})
		.state("champresultedit", {
			url: "/cre",
			params: {categoryId: null, raceId: null}, 
			template: require("./champ_resultedit.html"),
			controller: "ChampResultEditController",
			controllerAs: 'vm',
			authenticate: true 
		});
}


// WEBPACK FOOTER //
// ./client/app/backend/champs/champs.routes.js